import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Sponsor from "@/pages/Sponsor";
import Requests from "@/pages/Requests";
import RequestDetail from "@/pages/RequestDetail";
import Portfolio from "@/pages/Portfolio";
import Diagnostics from "@/pages/Diagnostics";
import PublicReceipt from "@/pages/PublicReceipt";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sponsor" element={<Sponsor />} />
          <Route path="/requests" element={<Requests />} />
          <Route path="/request/:id" element={<RequestDetail />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/diagnostics" element={<Diagnostics />} />
          <Route path="/r/:hash" element={<PublicReceipt />} />
          {/* legacy alias per spec */}
          <Route path="/receipt/:hash" element={<RedirectToShortReceipt />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

function RedirectToShortReceipt() {
  const path = window.location.pathname.replace("/receipt/", "/r/");
  return <Navigate to={path} replace />;
}

export default App;
